const steps = [
  { number: '01', title: 'Диагностика', desc: 'Аудит компетенций, анализ KPI, интервью с руководителями и сотрудниками. Определение текущего уровня и точек роста.' },
  { number: '02', title: 'План развития', desc: 'На основе диагностики формируется карта обучения: какие программы, в каком порядке, для каких групп сотрудников.' },
  { number: '03', title: 'Обучение', desc: 'Проведение программ в выбранных форматах: тренинги, воркшопы, онлайн-курсы, бизнес-игры. 20% теории, 80% практики.' },
  { number: '04', title: 'Практика', desc: 'Домашние задания, проектная работа, отработка навыков в реальных условиях. Закрепление знаний через действие.' },
  { number: '05', title: 'Сопровождение', desc: 'Посттренинговое сопровождение: чек-поинты через 2, 4 и 8 недель. Обратная связь, корректировка, поддержка руководителей.' },
  { number: '06', title: 'Оценка результатов', desc: 'Повторный замер KPI, анализ изменения поведения, расчёт ROI обучения. Отчёт для руководителя с выводами и рекомендациями.' },
  { number: '07', title: 'Новый цикл развития', desc: 'На основе оценки формируются цели на следующий период. Цикл повторяется — развитие непрерывно.' },
];

export default function ModernSystem() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Как должна выглядеть современная система обучения персонала
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Семь этапов замкнутого цикла — от диагностики до повторного развития. Именно так работает система, которая приносит измеримые бизнес-результаты.
        </p>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-0.5 bg-teal-200 -translate-x-1/2 hidden md:block"></div>

          <div className="space-y-8">
            {steps.map((step, i) => (
              <div key={i} className={`flex flex-col md:flex-row items-start gap-6 md:gap-10 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                  <div className="bg-white rounded-2xl p-6 border border-gray-100 hover:border-teal-200 hover:shadow-md transition-all">
                    <div className={`text-sm font-bold text-teal-600 mb-1 ${i % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>Этап {step.number}</div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{step.desc}</p>
                  </div>
                </div>
                <div className="relative z-10 flex-shrink-0">
                  <div className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center shadow-lg shadow-teal-600/25">
                    <span className="text-white font-bold text-sm">{step.number}</span>
                  </div>
                </div>
                <div className="flex-1 hidden md:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}